
import { defineComponent } from "vue";

export default defineComponent({
  name: "StatCard",
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    currencySymbol: { type: String, default: "€" },
    period: { type: String, default: "" },
    trend: { type: String, default: "" },
    trendUp: { type: Boolean, default: true },
    comparison: { type: String, default: "" },
    decimals: { type: Number, default: 2 },
    icon: { type: String, default: "media/icons/duotone/Shopping/Wallet2.svg" },
    compact: { type: Boolean, default: false },
  },
  computed: {
    formattedValue(): string {
      const value = Number(this.value) || 0;
      return value.toLocaleString(undefined, {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      });
    }
  }
});
